import React from 'react';
import { Button, Popconfirm, Tag } from 'antd';
import { getInferenceStatus } from '../../../lib/util/status';
import { ClassificationResult, InferenceFile } from '../../../types';
import { CustomLink } from '../../../components/CustomLink';

export const getDemoOverviewTableColumns = (
  onClickUrl: (inference: InferenceFile) => any,
  onDelete: (inference: InferenceFile) => any,
  isMultiflowAlgorithm: boolean | null
) => {
  const cols = [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      render: (text: string, record: InferenceFile) => (
        <span style={{ width: '100%', overflow: 'hidden' }}>
          <CustomLink
            style={{ marginRight: '16px' }}
            disabled={record.status === 'PROCESSING'}
            onClickUrl={onClickUrl(record)}>
            {text}
          </CustomLink>
          {isMultiflowAlgorithm &&
            (record.inferenceResult?.result?.type as ClassificationResult[])?.map(el => (
              <Tag key={el.name} style={{ margin: '4px' }}>
                {el.name}
              </Tag>
            ))}
        </span>
      ),
    },
    {
      title: 'Flow',
      key: 'flow',
      dataIndex: 'flow',
      render: (text: string, record: InferenceFile) => <span>{record.model.info.flowName}</span>,
    },
    {
      title: 'Customization',
      key: 'customization',
      dataIndex: 'customization',
      render: (text: string, record: InferenceFile) => (
        <span>{record.model.name !== 'Multimodel dummy' && record.model.name}</span>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text: string, record: InferenceFile) => (
        <span>
          <Tag color={getInferenceStatus(record).color} key={'READY'}>
            {getInferenceStatus(record).label}
          </Tag>
        </span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: InferenceFile) => (
        <span>
          <Popconfirm
            title="Are you sure to delete this invoice?"
            onConfirm={() => onDelete(record)}
            okText="Yes"
            cancelText="No">
            <Button type="link" style={{ marginLeft: '20px' }}>
              Delete
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];
  return isMultiflowAlgorithm ? cols : cols.filter(col => col.key !== 'flow');
};
